module.exports = __webpack_public_path__ + "img/bj@2x.15024c1c.png";